var winScrollTop=0;

function lateral() {

    var scrolled = $(window).scrollTop();

    if(scrolled > $(window).height()*2){

        $(".buehne .column.left").css("transform","translateY("+-scrolled+"px)");
        $(".buehne .column.right").css("transform","translateY("+-scrolled+"px)");
        $(".buehne .column.right").css("top","200vh");

    }else{

        $(".buehne .column.left").css("transform","translateY("+-scrolled+"px)");
        $(".buehne .column.right").css("transform","translateY("+scrolled+"px)");
        $(".buehne .column.right").css("top","-200vh");

    }

    if(scrolled+$(window).height() > $(".ghost").height()){
        $(".buehne").addClass('released');
    }else{
        $(".buehne").removeClass('released');
    }

}

$(window).scroll(function() {
    winScrollTop = $(this).scrollTop();
    lateral();
});

$(document).ready(function() {
    winScrollTop = $(this).scrollTop();
    lateral();
});
